<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>内部管理</el-breadcrumb-item>
      <el-breadcrumb-item>控股集团官网</el-breadcrumb-item>
      <el-breadcrumb-item>资质荣誉</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- Tabs -->
    <el-tabs v-model="activeName" type="border-card">
      <!-- 清单列表 strat -->
      <el-tab-pane label="清单列表" name="first">
        <!-- 查询用户 start -->
        <el-form :inline="true" :model="keywords" ref="keywordsRef" label-width="82px">
          <el-form-item label="">
            <el-select v-model="keywords.honortype" placeholder="请选择" class="select"  style="width: 200px;">
               <el-option
                 v-for="item in honortypeList" :key="item.value" :label="item.label" :value="item.value">
               </el-option>
             </el-select>
            </el-form-item>
          <el-form-item label="">
            <el-input v-model="keywords.title" @keyup.enter.native="clicksearch" placeholder="请输入标题" style="width: 150px;"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="clicksearch">查询</el-button>
          </el-form-item>
        </el-form>
        <!-- 查询用户 end -->

        <el-table :data="dataList" border stripe >
          <el-table-column prop="Listorder" label="排序" min-width="5%"></el-table-column>
          <el-table-column prop="Honortypes" label="类型" min-width="15%"></el-table-column>
          <el-table-column prop="Title" label="标题" min-width="10%"></el-table-column>
          <el-table-column prop="Picurl" label="图片链接" min-width="20%"></el-table-column>
          <el-table-column prop="Createtime" label="创建时间" min-width="15%"></el-table-column>
          <el-table-column label="操作" min-width="10%">
            <template v-slot="scope">
              <el-button type="text" size="mini" style="margin-left: 0; margin-right: 5px" @click="goEdit(scope.row)">修改</el-button>
              <el-button type="text" size="mini" style="margin-left: 0; margin-right: 5px" @click="goDel(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>

        <!-- 分页 -->
        <div class="pages">
          <el-pagination
            @current-change="handleCurrentPageChange"
            :page-size="10"
            layout="total, prev, pager, next, jumper"
            :total="dataListnum"
			:current-page.sync="selectedPageNo">
          </el-pagination>
        </div>
      </el-tab-pane>
      <!-- 清单列表 end -->

      <!-- 添加 start -->
      <el-tab-pane label="添加">
        <el-form :model="addData" ref="addDataRef" label-width="110px">
          <el-form-item label="类型">
            <el-select v-model="addData.honortype" placeholder="请选择" class="select">
              <el-option
                v-for="item in honortypeList" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="标题" class="addAdminForm">
            <el-input v-model="addData.title" placeholder="请输入标题"></el-input>
          </el-form-item>
          <el-form-item label="图片链接" class="addAdminForm">
            <el-input v-model="addData.picurl" placeholder="请输入图片链接"></el-input>
          </el-form-item>
          <el-form-item class="mt20">
            <el-button type="primary" @click="clickadd">添加</el-button>
            <el-button type="info" @click="BackToFirst">返回</el-button>
          </el-form-item>
        </el-form>
      </el-tab-pane>
      <!-- 添加 end -->

      <el-tab-pane label="修改" name="second" disabled="disabled">
        <KgjtWebsiteHonorEdit ref="SubVuesecond" v-on:triggerFunc="BackToFirst"></KgjtWebsiteHonorEdit>
      </el-tab-pane>

    </el-tabs>
    <!-- Tabs end -->
  </div>
</template>

<script>
import KgjtWebsiteHonorEdit from '@/componentsKgjt/KgjtWebsiteHonorEdit.vue'
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  components: {
    KgjtWebsiteHonorEdit
  },
  name: 'MyKgjtWebsiteHonor',
  data () {
    return {
      activeName: 'first',
      selectedPageNo: 1,
      dataList: [],
      dataListnum: 0,
      honortypeList: [],
      // 查询客户
      keywords: {
        honortype: '0',
        title: ''
      },
      // 添加
      addData: {
        honortype: '',
        title: '',
        picurl: ''
      }
    }
  },
  mounted () {
    this.honortypeList = Vue.prototype.FunGetHonortype()
    this.GetKgjtWebsiteHonorNum()
    this.GetKgjtWebsiteHonorList()
  },
  methods: {
    BackToFirst (val) {
      this.activeName = 'first'
      this.GetKgjtWebsiteHonorList()
    },
    handleCurrentPageChange (selectedPageNo) {
      this.GetKgjtWebsiteHonorList()
    },
    clicksearch () {
      this.selectedPageNo = 1
      this.GetKgjtWebsiteHonorNum()
      this.GetKgjtWebsiteHonorList()
    },
    clickadd () {
      this.AddKgjtWebsiteHonor()
    },
    // 修改
    goEdit (row) {
      this.activeName = 'second'
      this.$refs.SubVuesecond.LoadData(row)
    },
    // 删除
    goDel (row) {
      this.$confirm('是否删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.DelKgjtWebsiteHonor(row)
      })
    },
    // 产品特点
    goPic (row) {
      this.activeName = 'three'
      this.$refs.SubVuethree.LoadData(row)
    },
    GetKgjtWebsiteHonorList: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        pageno: that.selectedPageNo,
        honortype: that.keywords.honortype,
        title: that.keywords.title
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetKgjtWebsiteHonorList, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.dataList = response.data.List
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    GetKgjtWebsiteHonorNum: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        honortype: that.keywords.honortype,
        title: that.keywords.title
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetKgjtWebsiteHonorNum, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.dataListnum = response.data.Num
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    AddKgjtWebsiteHonor: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        honortype: that.addData.honortype,
        title: that.addData.title,
        picurl: that.addData.picurl
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_AddKgjtWebsiteHonor, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.activeName = 'first'

            that.addData.honortype = ''
            that.addData.title = ''
            that.addData.picurl = ''

            that.GetKgjtWebsiteHonorNum()
            that.GetKgjtWebsiteHonorList()
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    DelKgjtWebsiteHonor: function (row) {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        id: row.Id
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_DelKgjtWebsiteHonor, Qs.stringify(data))
        .then(function (response) {
          that.GetKgjtWebsiteHonorNum()
          that.GetKgjtWebsiteHonorList()
          Vue.prototype.FunCheckApiCode(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    }
  }
}
</script>

<style lang="less" scoped>
/deep/ .el-button--mini, .el-button--mini.is-round {
    padding: auto 5px;
}
.select{
   width: 202px;
}

.optometry {
    margin-top: 15px;
    padding: 20px;
    background: #FAFAFA;
    border: 1px solid #EBEEF5;

    & ul{
        flex-wrap: wrap;
        margin: 0;
        padding: 0;

        & li{
            width: 35%;
            line-height: 28px;
            color: #606266;
            list-style: none;
        }
    }
}
.mt20{
   margin-top: 20px;
}
</style>
